<SocialTags
	pageTitle="Recupera tu contraseña"
  pageDesc="Introduce tu correo electrónico con el que te registraste y si lo encontramos en nuestros registros te enviaremos un código de confirmación con el que podrás crear una nueva contraseña."
></SocialTags>

<style src='style.scss'>

</style>

<main id="dnsPage" class="mbsc-grid d-ns-page recover-password-page">
	<nav>
		<MainMenu
			on:menuTapped={togglePages}
		></MainMenu>
	</nav>

  <section class="mbsc-row">
    <div class="mbsc-col-12">
      <header>
        <h1>Recupera tu contraseña</h1>
        <p class="mbsc-col-12 mbsc-col-lg-8">
          Introduce tu correo electrónico con el que te registraste y si lo encontramos en nuestros registros te enviaremos un código de confirmación con el que podrás crear una nueva contraseña.
        </p>
        <p>
          ¿Ya recibiste tu código de confirmación? da click para
          <button mbsc-button class="mbsc-button mbsc-btn-info" on:click={enabledCode}>Ingresar código</button>
        </p>
      </header>
    </div>
    <div class="mbsc-col-12 mbsc-offset-md-3 mbsc-col-md-6">
      <div class="mbsc-align-center form-messages">
        <div class="mbsc-note mbsc-note-success">{@html successMessage}</div>
        <div class="mbsc-note mbsc-note-danger">{@html dangerMessage}</div>
        <div class="mbsc-note mbsc-note-warning">{@html warningMessage}</div>
      </div>
      <form class="recover-form">
        <div class="mbsc-form-group">
          <div class="mbsc-form-group-title">Introduce el correo electrónico con el que te registraste.</div>
          <label>
            <input mbsc-input name="email" id="email" type="email" placeholder="Correo electrónico" required data-icon="user4">
          </label>
          <label>
            <input mbsc-input name="text" id="code" type="text" placeholder="Código de confirmación" data-icon="checkmark" disabled>
          </label>
          <label>
            <input mbsc-input name="password" id="password" type="password" placeholder="Nuevo password" data-icon="lock2" disabled>
          </label>
        </div>
        <div class="mbsc-form-group mbsc-btn-group-block">
          <button mbsc-button id="md-success" data-icon="checkmark" on:click={validateForm}>Enviar código de recuperación</button>
        </div>
      </form>
    </div>
    <Banner
      title='Nuestras formas de Pago'
      description='Al comprar o renovar tu membresía puedes utilizar tu tarjeta de crédito o débito, y si lo haces desde tu teléfono móvil puedes utilizar las opciones de pago activadas para tu sistema operativo iOS o Android. Opcionalmente en el pago de tu anualidad también puedes utilizar Paypal y aprovechar sus opciones de pago a meses sin intereses.'
      image='/images/paypal-msi.jpg'
    ></Banner>
  </section>

	<footer class="mbsc-row">
		<nav class="mbsc-col-12">
			<FooterMenu></FooterMenu>
		</nav>
		<CopyrightFooter></CopyrightFooter>
	</footer>
</main>

<script>
  import { onMount, afterUpdate } from 'svelte';

  import SocialTags from '@Components/SocialTags/index.svelte';
  import MainMenu from '@Components/MainMenu/index.svelte';

  import Banner from '@Components/Banner/index.svelte';
  import FooterMenu from '@Components/FooterMenu/index.svelte';
  import CopyrightFooter from '@Components/CopyrightFooter/index.svelte';

  import { AWSAuth, Navigation, AWSAnalytics } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  export let router = null;

  let recoverForm = null, addedToFields = false;
  let successMessage = '';
  let warningMessage = '';
  let dangerMessage = '';

  let togglePages = (event) => {
    Navigation.goTo(event.detail.item);
  };

  let enabledCode = () => {
    document.querySelector('#code').disabled = false;
    document.querySelector('#password').disabled = false;
    document.querySelector('#md-success').innerHTML = 'Actualizar contraseña';

    document.querySelector('#code').focus();
  };

  let validateForm = async (event) => {
    event.preventDefault();

    document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'none';
    document.querySelector('.mbsc-note.mbsc-note-warning').style.display = 'none';
    dangerMessage = '';
    let formvalid = true;

    for (let f = 0; f < recoverForm.elements.length; f++) {
      let field = recoverForm.elements[f],
      name = field.name.charAt(0).toUpperCase() + field.name.slice(1),
      parent = field.parentNode,
      errorMsg = parent.querySelector('.mbsc-err-msg');

      if (name && field.validity.valid) {
        parent.parentNode.classList.remove('mbsc-err');

        if (errorMsg) {
          parent.removeChild(errorMsg);
        }
      } else if (name) {
        if (!errorMsg) {
          errorMsg = document.createElement('span');
          errorMsg.className = 'mbsc-err-msg';
          parent.appendChild(errorMsg);
        }

        var firstError = null;
        for (var key in field.validity) {
          if (!firstError && key !== 'valid' && field.validity[key]) {
            firstError = key;
          }
        }
        switch (firstError) {
          case 'tooShort':
          {
            errorMsg.innerHTML = name + ' es incorrecto';
            break;
          }
          case 'valueMissing':
          default:
          {
            errorMsg.innerHTML = name + ' es requerido';
            break;
          }
        }
        parent.parentNode.classList.add('mbsc-err');
        formvalid = false;
      }
    }

    if (formvalid && (event.type === 'click')) {
      const email = document.querySelector('#email').value;
      const code = document.querySelector('#code').value;
      const password = document.querySelector('#password').value;

      if (email && code && password) {
        AWSAuth.forgotPasswordSubmit(email, code, password).then((response) => {
          if (response === undefined) {
            // password update succeeded
            mobiscroll.alert({
              title: 'Nuevo password',
              message: 'Tu password ha sido actualizado correctamente.',
              callback: () => {
                Navigation.goTo('account');
              },
            });
          }else{
            if (typeof response.code === 'string'){
              warningMessage = response.message;
              document.querySelector('.mbsc-note.mbsc-note-warning').style.display = 'block';
              document.querySelector('#email').value = '';
              document.querySelector('#code').value = '';
              document.querySelector('#password').value = '';
            }else{
              dangerMessage = 'Ocurrió un error al recuperar la contraseña.';
              document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
            }
          }
        });
      }else{
        AWSAuth.forgotPassword(email).then((response) => {
          if (response === undefined) {
            dangerMessage = 'Ocurrió un error al recuperar la contraseña.';
            document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
          } else if ('CodeDeliveryDetails' in response) {
            successMessage = 'Por favor revisa tu bandeja de entrada en ' + response.code.CodeDeliveryDetails.Destination;
            document.querySelector('#code').enabled = true;
            document.querySelector('#password').enabled = true;
            document.querySelector('.md-success').innerHTML = 'Actualizar contraseña';
          } else if (typeof response.code === 'string'){
            if (DEBUG) console.log(response.code);
            if (response.code === 'NotAuthorizedException'){
              warningMessage = 'Nombre de usuario incorrecto.';
            } else {
              warningMessage = response.message;
            }
            document.querySelector('.mbsc-note.mbsc-note-warning').style.display = 'block';
            document.querySelector('#email').value = '';
            document.querySelector('#code').value = '';
            document.querySelector('#password').value = '';
          } else {
            dangerMessage = 'Ocurrió un error al recuperar la contraseña.';
            document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
          }
        });
      }
    } else if (!addedToFields) {
      addedToFields = true;
    } else if (!formvalid) {
      dangerMessage = 'Ocurrió un error al recuperar la contraseña.';
      document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
    }
    return false;
  };

afterUpdate(() => {
	mobiscroll.form('.recover-form', {});
});

onMount(async () =>{
  if (DEBUG) console.log('App::' + router.path);
  mobiscroll.settings = {
		theme: 'd-ns',
		themeVariant: 'light',
		lang: 'es'
  };
  
  recoverForm = document.querySelector('.recover-form');
  recoverForm.noValidate = true;

	mobiscroll.page('.recover-password-page', {});
});
</script>
